import React, { useState, useEffect } from "react";
import TableViewSearch from "../../../CustomComponent/TableViewSearch";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { Button, FormLabel, LinearProgress, MenuItem, Paper, Popover, Select, TextField, Tooltip, withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import ArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { ReactComponent as ActiveIcon } from "../../../images/commonicon/activeicon.svg";
import { ReactComponent as InactiveIcon } from "../../../images/commonicon/inactiveicon.svg";
import { Link, useNavigate } from "react-router-dom";

import { decryptData } from "../../../../crypto";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import OmrFileInput from "./OmrFileInput";
import PdfPreview from "./PdfPreview";
import CloseIcon from "@material-ui/icons/Close";

function ViewOmrScan() {
  const classes = useStyles();
  const style = [
    {
      height: 'maxh67',
      style: "viewtable",
    },
  ];
  const [anchorEl, setAnchorEl] = useState(null);
  const popoveropen = Boolean(anchorEl);
  const id = popoveropen ? "simple-popover" : undefined;
  const [selectedRowId, setSelectedRowId] = useState();
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const decryptedToken = decryptData(sessionStorage.getItem("token"));
  const [omrData, setOmrData] = useState([]);
  const navigate = useNavigate();
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const fetchExam = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/exam/active/all/exams`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setExams(response.data.exam);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchExam();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/upload/get/all/scan/${selectedExam}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      setOmrData(response.data.data);
      console.log("response.data", response.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  const handleScannerOMR = async () => {
    if (!selectedExam) {
      toast.warn("Please select exam");
      return;
    }
    if (selectedFiles.length === 0) {
      toast.warn("Please select file");
      return;
    }

    try {
      setIsUploading(true);
      setUploadProgress(0);

      // Simulate progress with setInterval
      const interval = setInterval(() => {
        setUploadProgress((prevProgress) => {
          const newProgress = prevProgress + 1;
          if (newProgress >= 100) {
            clearInterval(interval);
            return 100;
          }
          return newProgress;
        });
      }, 100);

      const formData = new FormData();
      formData.append("exam_id", selectedExam);
      // Append each file to FormData
      selectedFiles.forEach((file, index) => {
        formData.append("file", file);
      });

      console.log("FormData contents:");
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value.name || value}`);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/v1/client/upload/scan`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );


      clearInterval(interval); // Clear interval when API call completes
      setIsUploading(false);
      setUploadProgress(100);

      fetchData();
      toast.success("File Readed Successfully");
      // setSelectedExam("");
      setSelectedFiles([]);
      handleClose();

    } catch (error) {
      console.error("Error while reading the file :", error);
      // toast.error("OMR File not Readed ", error);
       toast.error(error.response.data.message,"OMR File not Readed ");
      // toast.error(error, "OMR File not Readed ");
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const handleRemoveFile = (indexToRemove) => {
    const updatedFiles = selectedFiles.filter((_, index) => index !== indexToRemove);
    setSelectedFiles(updatedFiles);
  };

  console.log("selectedExam", selectedExam);

  const viewUserResult = () => {
    navigate(`/admin/examresult/${selectedExam}`);
    // console.log("selectedExam-----------------",selectedExam)
  }
  return (
    <>
      <ToastContainer />
      <div
        className={` ${classes.w100} ${classes.alignitemStart} ${classes.p1} ${classes.borderradius6px} ${classes.inputpadding} ${classes.inputborder} ${classes.inputplaceholdercolorblack} ${classes.dflex}`}
      >
        <div
          className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
                    ${classes.lineheight}`}
          >Exam<span className={classes.textcolorred}>*</span></FormLabel>
          <Select
            labelId="category-label"
            id="state"
            value={selectedExam}
            onChange={(e) => {
              setSelectedExam(e.target.value);
              setOmrData([]);
              // setSelectedFiles([]);
            }}
            displayEmpty
            className={classes.selectEmpty}
            MenuProps={menuProps}
            variant="outlined"
          >
            <MenuItem disabled value="">
              <em className={classes.defaultselect}>Select Exam</em>
            </MenuItem>
            {exams &&
              exams.map((st) => (
                <MenuItem key={st.id} value={st.id}>
                  {st?.exam_name}
                </MenuItem>
              ))}
          </Select>
        </div>

        <div
          className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w24}`}
        >
          <FormLabel
            className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} 
                    ${classes.lineheight}`}
          >Upload File<span className={classes.textcolorred}>*</span></FormLabel>
          <OmrFileInput
            setSelectedFiles={setSelectedFiles}
            selectedFiles={selectedFiles}
          />
        </div>

        <div
          className={`${classes.dflex}  ${classes.mx0_5} ${classes.flexdirectioncolumn} ${classes.w20} ${classes.mt1_5}`}
        >
          <Button className={`${classes.scanButton}`} onClick={handleScannerOMR}>Read Sheet</Button>
        </div>
      </div>
      <div
        className={`${classes.bgwhite} ${classes.alignitemsend} ${classes.justifyspacebetween} ${classes.inputpadding} ${classes.inputborder} ${classes.boxshadow3} ${classes.borderradius6px}`}
      >
        {/* <TableViewSearch Heading={Heading} onSearch={handleSearch} /> */}
        {/* <TableView columns={columns} rows={filteredRows} Heading={style} /> */}


        {isUploading && (
          <div style={{ padding: "15px" }}>
            <LinearProgress
              variant="determinate"
              value={uploadProgress}
              style={{
                borderRadius: 8,
              }}
            />
            <div style={{ textAlign: "center", marginTop: "8px" }}>
              Reading: {uploadProgress}%
            </div>
          </div>
        )}

        {(selectedFiles.length > 0 || omrData.some((data) => data.photo_url)) ?

          (
            <div>
              {/* selectedFiles */}
              {selectedFiles.length > 0 && (
                <div>
                  {selectedFiles.map((file, index) => (
                    <div key={`file-${index}`} className={classes.uploadedPdfBox} style={{ padding: "15px" }}>
                      {file.type.startsWith("image/") ? (
                        <div className={classes.relativePostition} style={{ width: "76%" }}>
                          <IconButton
                            onClick={() => handleRemoveFile(index)}
                            style={{
                              position: "absolute",
                              top: 6,
                              right: 6,
                              zIndex: 10,
                              backgroundColor: "transparent",
                              padding: 4,
                            }}
                          >
                            <CloseIcon style={{ color: "#f44336" }} />
                          </IconButton>
                          <img
                            src={URL.createObjectURL(file)}
                            alt={file.name}
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "4px",
                              border: "2px solid black",
                            }}
                          />
                        </div>
                      ) : file.type === "application/pdf" ? (
                        <PdfPreview
                          file={file}
                          handleRemoveFile={handleRemoveFile}
                          index={index}
                        />
                      ) : file.name.toLowerCase().endsWith(".zip") || file.type === "application/zip" || file.type === "application/x-zip-compressed" ? (
                        <div style={{ position: "relative", width: "100%" }}>
                          <IconButton
                            onClick={() => handleRemoveFile(index)}
                            style={{
                              position: "absolute",
                              top: 6,
                              right: 6,
                              zIndex: 10,
                              backgroundColor: "transparent",
                              padding: 4,
                            }}
                          >
                            <CloseIcon style={{ color: "#f44336" }} />
                          </IconButton>
                          <div style={{ padding: "12px", border: "1px dashed #ccc", borderRadius: 4 }}>
                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                              ZIP File
                            </Typography>
                            <Typography variant="body2">{file.name}</Typography>
                          </div>
                        </div>
                      ) : (
                        <div style={{ position: "relative", width: "100%" }}>
                          <IconButton
                            onClick={() => handleRemoveFile(index)}
                            style={{
                              position: "absolute",
                              top: 6,
                              right: 6,
                              zIndex: 10,
                              backgroundColor: "transparent",
                              padding: 4,
                            }}
                          >
                            <CloseIcon style={{ color: "#f44336" }} />
                          </IconButton>
                          <div style={{ padding: "12px", border: "1px dashed #ccc", borderRadius: 4 }}>
                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                              Selected File
                            </Typography>
                            <Typography variant="body2">{file.name}</Typography>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* omr files */}
              {omrData.some((data) => data.photo_url) && (
                <>
                  <div 
                 
                  className={`${classes.textaligncenter} ${classes.mt1} ${classes.fw600} 
               ${classes.pt1} ${classes.mb1}`}>
                    File reading completed

                    <Button className={`${classes.scanButton} ${classes.ml1}`} onClick={viewUserResult}>View result</Button>
                  </div>
                  <div>
                    {omrData.map((data, index) => (
                      data.photo_url && (
                        <div key={`photo-${index}`} className={classes.uploadedPdfBox} style={{ padding: "15px" }}>
                          {data.photo_url.match(/\.(jpeg|jpg|png|gif)$/i) ? (
                            <div className={classes.relativePostition} style={{ width: "76%" }}>
                              <div className={classes.fontsize1}><span style={{ fontWeight: 600 }}>Roll Number:</span> {data.roll_number}</div>
                              <img
                                src={data.photo_url}
                                alt={`Uploaded file ${index}`}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "4px",
                                  border: "2px solid black",
                                }}
                                onError={(e) => console.error("Error loading image:", data.photo_url)}
                              />
                            </div>
                          ) : data.photo_url.match(/\.pdf$/i) ? (
                            <PdfPreview
                              file={data.photo_url}
                              handleRemoveFile={() => { }}
                              index={index}
                            />
                          ) : null}
                        </div>
                      )
                    ))}
                  </div>
                </>
              )}
            </div>
          )
          : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '300px' }}>
            No files added yet</div>
        }
      </div>
    </>
  );
}
export default ViewOmrScan;
